import React, {useContext} from 'react';
import {Button, Col, Descriptions, Row, Space, theme} from 'antd';
import {observer} from "mobx-react";
import {Link, useLoaderData, useNavigate} from "react-router-dom";
import {ButtonBar} from "../../../builder";
import {Translate} from "../../../components/util/translation.util";
import AccessUtil from "../../../components/util/access.util";
import {TranslationDomainEnum} from "../../../types/enums";
import {ServicerViewResponse} from "../../../types/modules/servicer/response";
import {ViewCardStyled} from "../../../components/styled/card.styled";
import FoAccessUtil from "../../../components/util/foAccess.util";
import FoLink from "../../../components/link/fo.link";
import {StoreContext} from "../../../store.context";
import {Helmet} from "react-helmet-async";

export const View: React.FC = observer(() => {
   const {token} = theme.useToken();
   const {
      appStore: {
         countries,
      }
   } = useContext(StoreContext);

   const navigate = useNavigate();
   const data: ServicerViewResponse = useLoaderData() as ServicerViewResponse;

   return (
           <>
              <Helmet>
                 <title>{`CL BO - ${data?.name} - ${data?.tpNumber}`}</title>
              </Helmet>
              <Space direction="vertical" size="small" style={{display: 'flex'}}>
                 <Row gutter={[8, 8]}>
                    <Col span={12}>
                       <Space direction={'vertical'} style={{width: '100%'}}>
                          <ViewCardStyled title={
                             <Translate message={`servicer.title.company`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION}/>
                          } style={{
                             background: token.colorBgContainer,
                          }}>
                             <div className={`view-block-wrapper`}>
                                <Descriptions bordered>
                                   <Descriptions.Item label={<Translate message={`servicer.fields.relationalId`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION}/>} span={3}>{data.id}</Descriptions.Item>
                                   <Descriptions.Item label={<Translate message={`servicer.fields.name`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION}/>} span={3}>{data.name}</Descriptions.Item>
                                   <Descriptions.Item label={<Translate message={`servicer.fields.externalId`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION}/>} span={3}>{data.externalId}</Descriptions.Item>
                                </Descriptions>
                             </div>
                          </ViewCardStyled>

                          <ViewCardStyled title={
                             <Translate message={`servicer.title.contact_data`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION}/>
                          } style={{
                             background: token.colorBgContainer,
                          }}>
                             <div className={`view-block-wrapper`}>
                                <Descriptions bordered>
                                   <Descriptions.Item label={<Translate message={`companyContactData.fields.phone`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION}/>} span={3}>
                                      {data.contactData.phone}
                                   </Descriptions.Item>
                                   <Descriptions.Item label={<Translate message={`companyContactData.fields.email`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION}/>} span={3}>
                                      {data.contactData.email}
                                   </Descriptions.Item>
                                </Descriptions>
                             </div>
                          </ViewCardStyled>

                          <ViewCardStyled title={
                             <Translate message={`servicer.title.address`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION}/>
                          } style={{
                             background: token.colorBgContainer,
                          }}>
                             <div className={`view-block-wrapper`}>
                                <Descriptions bordered>
                                   <Descriptions.Item label={<Translate message={`companyAddress.fields.country`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION}/>} span={3}>
                                      {countries.find((country) => {
                                         return country.id === data.address.country
                                      })?.name}
                                   </Descriptions.Item>
                                   <Descriptions.Item label={<Translate message={`companyAddress.fields.postalCode`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION}/>} span={3}>
                                      {data.address.postalCode}
                                   </Descriptions.Item>
                                   <Descriptions.Item label={<Translate message={`companyAddress.fields.houseNumber`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION}/>} span={3}>
                                      {data.address.houseNumber}
                                   </Descriptions.Item>
                                   <Descriptions.Item label={<Translate message={`companyAddress.fields.houseNumberAdditions`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION}/>} span={3}>
                                      {data.address.houseNumberAdditions}
                                   </Descriptions.Item>
                                   <Descriptions.Item label={<Translate message={`companyAddress.fields.street`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION}/>} span={3}>
                                      {data.address.street}
                                   </Descriptions.Item>
                                   <Descriptions.Item label={<Translate message={`companyAddress.fields.city`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION}/>} span={3}>
                                      {data.address.city}
                                   </Descriptions.Item>
                                </Descriptions>
                             </div>
                          </ViewCardStyled>

                          <ViewCardStyled title={
                             <Translate message={`servicer.title.updates`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION}/>
                          } style={{
                             background: token.colorBgContainer,
                          }}>
                             <div className={`view-block-wrapper`}>
                                <Descriptions bordered>
                                   <Descriptions.Item label={<Translate message={`global.title.created_or_updated_date`} domain={TranslationDomainEnum.MESSAGES}/>} span={3}>
                                      {data.modifiedDate}
                                   </Descriptions.Item>
                                    <Descriptions.Item label={<Translate message={`global.title.created_or_updated_by`} domain={TranslationDomainEnum.MESSAGES} />} span={3}>
                                        {data.modifiedBy ? (
                                                <AccessUtil access={{ routeName: 'user_view', attributes: [{ id: data.modifiedBy.id  }]}}>
                                                    <AccessUtil access={{ routeName: 'user_view', attributes: [{ id: data.modifiedBy.id  }]}} onDenied={() => {
                                                        return data.modifiedBy?.username ?? data.modifiedBy?.id;
                                                    }}>
                                                        <Link target={"_blank"} to={`/user/${data.modifiedBy?.id}/view`}>{ data.modifiedBy.username ?? data.modifiedBy.id }</Link>
                                                    </AccessUtil>
                                                </AccessUtil>
                                        ) : (
                                                <Translate message={`global.system`} domain={TranslationDomainEnum.MESSAGES} />
                                        )}
                                    </Descriptions.Item>
                                </Descriptions>
                             </div>
                          </ViewCardStyled>
                       </Space>
                    </Col>
                    <Col span={12}>
                       <Space direction={'vertical'} style={{width: '100%'}}>
                          <ViewCardStyled title={
                             <Translate message={`servicer.title.reference_numbers`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION}/>
                          } style={{
                             background: token.colorBgContainer,
                          }}>
                             <div className={`view-block-wrapper`}>
                                <Descriptions bordered>
                                   <Descriptions.Item label={<Translate message={`servicer.fields.tpNumber`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION}/>} span={3}>{data.tpNumber}</Descriptions.Item>
                                   <Descriptions.Item label={<Translate message={`servicer.fields.wft`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION}/>} span={3}>{data.wft}</Descriptions.Item>
                                   <Descriptions.Item label={<Translate message={`servicer.fields.chamberOfCommerceNumber`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION}/>} span={3}>{data.chamberOfCommerceNumber}</Descriptions.Item>
                                </Descriptions>
                             </div>
                          </ViewCardStyled>

                          <ViewCardStyled title={
                             <Translate message={`servicer.title.contract_information`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION}/>
                          } style={{
                             background: token.colorBgContainer,
                          }}>
                             <div className={`view-block-wrapper`}>
                                <Descriptions bordered>
                                   <Descriptions.Item label={<Translate message={`servicer.fields.activeContract`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION}/>} span={3}>
                                      {data.activeContract ? <Translate message={`global.yes`}/> : <Translate message={`global.no`}/>}
                                   </Descriptions.Item>
                                   <Descriptions.Item label={<Translate message={`servicer.fields.origin`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION}/>} span={3}>
                                      <Translate message={data.origin.name} domain={TranslationDomainEnum.MESSAGES}/>
                                   </Descriptions.Item>
                                   <Descriptions.Item label={<Translate message={`servicer.fields.allowedProductTypes`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION}/>} span={3}>
                                      {data.allowedProductTypes.map(
                                              (pt, index) => (
                                                      <span key={index}>
                                                    <Translate message={pt.name} domain={TranslationDomainEnum.MESSAGES}/>
                                                         {data.allowedProductTypes.length === index + 1 ? null : ', '}
                                                </span>
                                              )
                                      )}
                                   </Descriptions.Item>
                                </Descriptions>
                             </div>
                          </ViewCardStyled>

                          <ViewCardStyled title={
                             <Translate message={`servicer.title.reference_numbers`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION}/>
                          } style={{
                             background: token.colorBgContainer,
                          }}>
                             <div className={`view-block-wrapper`}>
                                <Descriptions bordered>
                                   <Descriptions.Item label={<Translate message={`companyBankData.fields.iban`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION}/>} span={3}>
                                      {data.bankData?.iban}
                                   </Descriptions.Item>
                                   <Descriptions.Item label={<Translate message={`companyBankData.fields.accountHolderName`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION}/>} span={3}>
                                      {data.bankData?.accountHolderName}
                                   </Descriptions.Item>
                                   <Descriptions.Item label={<Translate message={`servicer.fields.agencyCommission`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION}/>} span={3}>
                                      <Translate message={data.agencyCommission.name} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION}/>
                                   </Descriptions.Item>
                                   {
                                           data.agencyCommissionServicer && (
                                                   <Descriptions.Item label={<Translate message={`servicer.fields.agencyCommissionServicer`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION}/>} span={3}>
                                                      <AccessUtil access={{routeName: 'servicer_view', attributes: [{id: data.agencyCommissionServicer?.id}]}}>
                                                         <Link to={`/servicer/${data.agencyCommissionServicer?.id}/view`} target={"_blank"}>
                                                            {data.agencyCommissionServicer?.name}
                                                         </Link>
                                                      </AccessUtil>
                                                   </Descriptions.Item>
                                           )
                                   }
                                   {
                                           data.agencyCommissionRelationalNumber && (
                                                   <Descriptions.Item label={<Translate message={`servicer.fields.agencyCommissionRelationalNumber`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION}/>} span={3}>
                                                      {data.agencyCommissionRelationalNumber}
                                                   </Descriptions.Item>
                                           )
                                   }
                                   <Descriptions.Item label={<Translate message={`servicer.fields.servicerCommission`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION}/>} span={3}>
                                      <Translate message={data.servicerCommission.name} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION}/>
                                   </Descriptions.Item>
                                   {
                                           data.servicerCommissionServicer && (
                                                   <Descriptions.Item label={<Translate message={`servicer.fields.servicerCommissionServicer`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION}/>} span={3}>
                                                      <AccessUtil access={{routeName: 'servicer_view', attributes: [{id: data.servicerCommissionServicer?.id}]}} onDenied={() => {
                                                         return data.servicerCommissionServicer?.name;
                                                      }}>
                                                         <Link target={"_blank"} to={`/servicer/${data.servicerCommissionServicer?.id}/view`}>
                                                            {data.servicerCommissionServicer?.name}
                                                         </Link>
                                                      </AccessUtil>
                                                   </Descriptions.Item>
                                           )
                                   }
                                   {
                                           data.servicerCommissionRelationalNumber && (
                                                   <Descriptions.Item label={<Translate message={`servicer.fields.servicerCommissionRelationalNumber`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION}/>} span={3}>
                                                      {data.servicerCommissionRelationalNumber}
                                                   </Descriptions.Item>
                                           )
                                   }
                                   <Descriptions.Item label={<Translate message={`servicer.fields.stopExcasso`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION}/>} span={3}>
                                      {data.stopExcasso ? <Translate message={`global.yes`}/> : <Translate message={`global.no`}/>}
                                   </Descriptions.Item>
                                   <Descriptions.Item label={<Translate message={`servicer.fields.sendMonthlyOverview`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION}/>} span={3}>
                                      {data.sendMonthlyOverview ? <Translate message={`global.yes`}/> : <Translate message={`global.no`}/>}
                                   </Descriptions.Item>
                                   {
                                           data.monthlyOverviewEmail && (
                                                   <Descriptions.Item label={<Translate message={`servicer.fields.monthlyOverviewEmail`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION}/>} span={3}>
                                                      {data.monthlyOverviewEmail}
                                                   </Descriptions.Item>
                                           )
                                   }
                                </Descriptions>
                             </div>
                          </ViewCardStyled>
                       </Space>
                    </Col>
                 </Row>

                 <ButtonBar>
                    <AccessUtil access={{routeName: 'servicer_edit', attributes: [{id: data.id}]}}>
                       <Space>
                          <Button type={`primary`} onClick={() => navigate(`/servicer/${data.id}/edit`)}>
                             <Translate message={`global.button.edit`}/>
                          </Button>
                       </Space>
                    </AccessUtil>

                    <AccessUtil access={{routeName: 'servicer_view_history', attributes: [{id: data.id}]}}>
                       <Space>
                          <Button type={`primary`} className={`ant-btn-secondary`} onClick={() => navigate(`/servicer/${data.id}/view_history`)}>
                             <Translate message={`global.button.view_history`}/>
                          </Button>
                       </Space>
                    </AccessUtil>

                    <AccessUtil access={{routeName: 'servicer_agency_list', attributes: [{id: data.id}]}}>
                       <Space>
                          <Button type={`primary`} className={`ant-btn-secondary`} onClick={() => navigate(`/servicer/${data.id}/agency_list`)}>
                             <Translate message={`global.button.agency_list`}/>
                          </Button>
                       </Space>
                    </AccessUtil>

                    <Button type="primary" className={`ant-btn-secondary`} onClick={() => navigate(`/servicer`)}>
                       <Translate message={`global.button.back_to_list`}/>
                    </Button>

                    <FoAccessUtil>
                       <Space>
                          <FoLink path={`/servicer/${data.id}/view_bo_id`} message="global.button.view_in_fo"></FoLink>
                       </Space>
                    </FoAccessUtil>
                 </ButtonBar>
              </Space>
           </>
   )
})